/**
 * @module 信保达iOS相关模块路由
 */
export default [
  // 我的客服 - 审核中
  {
    path: '/ds/mine/service',
    name: 'ds_mine_service',
    component: () => import('@/pages/app/ds-app/mine/service.vue'),
    meta: {
      title: '我的客服'
    }
  },
  {
    path: '/ds/protocol/register',
    name: 'ds_protocol_register',
    component: () => import('@/pages/app/ds-app/protocol/register.vue'),
    meta: {
      title: '用户服务协议'
    }
  },
  {
    path: '/ds/protocol/private',
    name: 'ds_protocol_private',
    component: () => import('@/pages/app/ds-app/protocol/private.vue'),
    meta: {
      title: '用户隐私保护政策'
    }
  }
]
